export default {
    childrenStyles: {
        padding: "10px"
    },
    customPopupStyles: {
        padding: "10px	",
        maxWidth: "70%"
    },
    popupBodyWrapper: {
        padding: "10px",
        width: "95%",
        margin: 'auto'
    },
    fw600: {
        fontWeight: "600"
    },
    buttonsContainer: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        columnGap: "20px",
        padding: "15px"
    }
}